module.exports = __webpack_public_path__ + "static/media/Daniela Steinsapir.50635060.png";